import {
  GET_DATA_INTEGRATIONS,
  GET_DATA_INTEGRATIONS_FAILED,
  GET_DATA_INTEGRATIONS_SUCCEEDED,
  SYNC_DATA_INTEGRATION,
  SYNC_DATA_INTEGRATION_FAILED,
  SYNC_DATA_INTEGRATION_SUCCEEDED,
  CONNECT_DATA_INTEGRATION,
  CONNECT_DATA_INTEGRATION_FAILED,
  CONNECT_DATA_INTEGRATION_SUCCEEDED,
  DISCONNECT_DATA_INTEGRATION,
  DISCONNECT_DATA_INTEGRATION_FAILED,
  DISCONNECT_DATA_INTEGRATION_SUCCEEDED,
  GET_QUICKBOOK_CONNECTION,
  GET_QUICKBOOK_CONNECTION_FAILED,
  GET_QUICKBOOK_CONNECTION_SUCCEEDED,
} from 'Redux/Types/DataIntegrationTypes'

const INITIAL_STATE = {
  loading: false,
  integrations: [],
  quickBookData: {},
  creatingQuickBookConnection: false,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_DATA_INTEGRATIONS:
      return {
        ...state,
        loading: true,
      }
    case GET_DATA_INTEGRATIONS_FAILED:
      return {
        ...state,
        loading: false,
      }
    case GET_DATA_INTEGRATIONS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        integrations: payload,
      }
    case GET_QUICKBOOK_CONNECTION:
      return {
        ...state,
        loading: true,
        creatingQuickBookConnection: true,
      }
    case GET_QUICKBOOK_CONNECTION_FAILED:
      return {
        ...state,
        loading: false,
        creatingQuickBookConnection: false,
      }
    case GET_QUICKBOOK_CONNECTION_SUCCEEDED:
      return {
        ...state,
        loading: false,
        creatingQuickBookConnection: false,
        quickBookData: payload,
      }

    case SYNC_DATA_INTEGRATION:
      return {
        ...state,
        loading: true,
        integrations: state.integrations.map((integration) => {
          if (integration.type === payload.type) {
            return { ...integration, syncing: true, synced: false }
          }
          return integration
        }),
      }
    case SYNC_DATA_INTEGRATION_FAILED:
      return {
        ...state,
        loading: false,
        integrations: state.integrations.map((integration) => {
          if (integration.type === payload.type) {
            return { ...integration, syncing: false, synced: false }
          }
          return integration
        }),
      }
    case SYNC_DATA_INTEGRATION_SUCCEEDED:
      return {
        ...state,
        loading: false,
        integrations: state.integrations.map((integration) => {
          if (integration.type === payload.type) {
            return { ...integration, syncing: false, synced: true }
          }
          return integration
        }),
      }

    case CONNECT_DATA_INTEGRATION:
      return {
        ...state,
        loading: true,
        connected: false,
      }
    case CONNECT_DATA_INTEGRATION_FAILED:
      return {
        ...state,
        loading: false,
        connected: false,
      }
    case CONNECT_DATA_INTEGRATION_SUCCEEDED:
      return {
        ...state,
        loading: false,
        connected: true,
      }

    case DISCONNECT_DATA_INTEGRATION:
      return {
        ...state,
        loading: true,
        disconnected: false,
      }
    case DISCONNECT_DATA_INTEGRATION_FAILED:
      return {
        ...state,
        loading: false,
        disconnected: false,
      }
    case DISCONNECT_DATA_INTEGRATION_SUCCEEDED:
      return {
        ...state,
        loading: false,
        disconnected: true,
      }

    default:
      return state
  }
}
